<template>
<div>
    <section class="page-title" style="background-color:#e2f1f2;">
    <div class="center">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg7>
        <p class="label-planos">Convênio Plano Odontológico</p>
        <h1 class="the-title">Projeto</h1>
        <h1 class="the-title" style="font-size: 40px;"><span style="color:#009b9b;">Pró-PM - Pessoa Física</span></h1>         
        </v-flex>  
        <v-flex xs12 sm12 lg5>  
             <v-img src="https://static.wixstatic.com/media/0e7ab6_6a9fb506e7b040d292dc2f5827651a44~mv2.png" max-width="500px" ></v-img>
        </v-flex>
        <v-flex xs12 sm12 lg12 >
          <img src="../Content/images/PM.png" width="260px">
          <div class="planos-wrapper" style="background-color:#b7d9d9;">
          <p class="planos-title">Faça já a sua adesão</p>
          <v-layout align-center>
        <v-flex xs12 sm12 lg12>
          <v-card
          flat
          max-height="600px"
          max-width="450px"
          class="mx-auto localizacao"
          style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
          <v-card-text>
              <v-flex xs12 sm12 lg12>
              <v-container grid-list-md>
              <v-layout align-center justify-center row wrap>
              <v-flex xs12 sm12 lg8>      
              <v-text-field
              v-model="matricula"
              label="Nº do RE (Registro Estatístico)"
              v-validate="'required'"
              :error-messages="errors.collect('carteirinha')"
              data-vv-name="carteirinha" 
              mask="#########################"     
              ></v-text-field>
              </v-flex>    
              <v-flex xs7 sm7 md7 lg4 >
              <v-btn
              style="border-radius: 6px;"               
              dark
              depressed
              @click="openDialog()"
              color="#009b9b"
              >Aderir agora</v-btn>
            </v-flex>
              <!-- </v-layout> -->
              </v-layout>
              </v-container>
              </v-flex>
          </v-card-text>
          </v-card>
        </v-flex>
        </v-layout>
        </div>
        </v-flex>      
        </v-layout>
    </div>
</section>

<section class="page-content center">
    <v-layout row wrap>
    <v-flex xs12 sm12 lg8>
    <p class="title-label">A parceria perfeita para o Sócio Pró-PM cuidar do sorriso de toda a sua família</p>
    <p>Aproveite a oportunidade de levar saúde bucal de qualidade para você e sua família em condições imperdíveis. </p>
    <!--<p style="font-weight: bold; font-size: 15px;">Taxa de implantação R$ 4,00 por beneficiário (Apenas na primeira mensalidade).</p>-->
    </v-flex>

    <v-flex xs12 sm12 lg4 style="text-align: end;">
    <!-- <img src="../Content/images/preco_titular.png" width="100px">&nbsp;
    <img src="../Content/images/valor_estagiario.png" width="100px">&nbsp;
    <img src="../Content/images/preco_dependente.png" width="100px">&nbsp; -->
    <img src="../Content/images/preco_titular2.png" width="100px">&nbsp;
    <img src="../Content/images/preco_dependente2.png" width="100px">&nbsp;
    <!--<img src="../Content/images/preco.png" width="150px">-->
    </v-flex>

    <v-flex xs12 sm12 lg7>
    <p class="title-label">Acesso à rede credenciada</p>
    <p>Para acessar a rede credenciada, <a href="http://www.primavida.com.br/redecredenciada" target="_blank">clique aqui.</a></p>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <br>
    <p class="title-label">Quem pode aderir ao Plano?</p>
    <ul>Dependentes:</ul>
    <li>Pai / Padrasto</li>
    <li>Mãe / Madrasta</li>
    <li>Filhos / Enteados</li>
    <li>Cônjuge / Companheiro</li>
    <br>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <br>
    <p class="title-label">Principais Vantagens</p>
    <!-- <p>A Primavida tem planos atrativos, flexíveis e acessíveis para você e sua família, confira:</p> -->
    <li>Credenciamento de dentista por indicação</li>
    <li>Inclusão de dependentes e agregados</li>
    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
    <li>Autorização de tratamentos on-line</li>
    <li>Abrangência Grupo de Municípios SP</li>
    <li>Sem limites para utilização</li>
    <li>Aplicativo para celular</li>
    <br>


    </v-flex>

    <v-flex xs12 sm12 lg7>    
    <p class="title-label">Carências Reduzidas</p>    
    <table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
       
        <tr class="mini-header">
            <td>Procedimentos / Eventos Odontológicos</td>
            <th >Prazo de Carência</th>
            <!-- <td>Plano Individual/Familiar</td> -->
        </tr>
        <tr>
            <td>Consulta de Urgência</td>
            <!-- <td>24 horas</td> -->
            <td class="carencia">24 horas</td>
        </tr>
        <tr>
            <td>Consulta inicial, Radiologia, Prevenção, Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>
            <!-- <td>30 dias</td> -->
            <td class="carencia">30 dias</td>
        </tr>
        <tr>
            <td>Endodontia e Prótese</td>
            <!-- <td>180 dias</td> -->
            <td class="carencia">180 dias</td>
        </tr>
    </table>
    </v-flex>
    
       
    <v-flex xs5 sm5 lg12>
    <br>
                    <table cellpadding="0" cellspacing="0" border="1">
                        <tr >
                            <td style="color: #009b9b;">Plano: </td> 
                            <td>&nbsp; SMILE CLASS </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Reg ANS nº: </td>
                            <td>&nbsp; 484.400/19-9 </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Tipo de Contratação: </td>
                            <td>&nbsp; INDIVIDUAL / FAMILIAR </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Formação de Preço: </td>
                            <td>&nbsp; PRÉ-ESTABELECIDO </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Área de Abrangênia/Atuação: </td>
                            <td>&nbsp; GRUPO DE MUNICÍPIOS SP </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Segmetação Assistencial: </td>
                            <td>&nbsp; EXCLUSIVAMENTE ODONTOLÓGICA </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Carência: </td>
                            <td>&nbsp; CARÊNCIAS REDUZIDAS</td>
                        </tr>
                       </table>
    </v-flex>
    
    <v-flex xs5 sm5 lg2>
    <br>
                    <img src="../Content/images/app_android.png" width="120px"><br>
                    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_apple.png" width="120px"><br>
                    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_whats.png" width="120px"><br>
                    <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg3>
                    <img src="../Content/images/celular.png" width="130px"><br>
                <br>
                </v-flex>
    </v-layout>
    <br>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico) e panorâmica;</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div>
    <!-- <v-flex xs12 sm6 md6 lg6 >
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        href="https://www.ecommerce.primavida.com.br/contratopf?plano=5e1f3ce310b13354a58b610d&parceria=avanti"
        color="#009b9b"
        >Faça já a sua adesão</v-btn>
    </v-flex> -->
</section>
<v-dialog v-model="dialog" max-width="650px" max-height="400px" persistent> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) beneficiário(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!contrataccept" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/ContratoPFsemvalor?plano=5e1f3ce310b13354a58b610d&carteirinha='+matricula">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
/* import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global' */
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número do RE'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

        //this.carregaDados()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(){
            if(this.matricula != '')
            this.dialog = true
            else
            this.$validator.validateAll()
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .imagemcaarj{
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
</style>